import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatrixCellFieldComponent } from './matrix-cell-field.component/matrix-cell-field.component';

@NgModule({
  declarations: [MatrixCellFieldComponent],
  imports: [CommonModule],
  exports: [MatrixCellFieldComponent],
  providers: [],
})
export class MatrixModule { }
